import { render } from "./DReceivedBatches.vue?vue&type=template&id=6bdcf138"
import script from "./DReceivedBatches.vue?vue&type=script&lang=js"
export * from "./DReceivedBatches.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__